import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';

interface IProps {
	toggleIsDisabled: () => void;
	isDisabled: boolean;
}

export const IsDisabledCheckbox: React.FC<IProps> = React.memo(({ toggleIsDisabled, isDisabled }) => {
	return (
		<Form.Item name="isDisabled" data-test="IsDisabledCheckbox">
			<Checkbox onChange={toggleIsDisabled} checked={isDisabled}>
				<Text translationNameSpace="form" translationKey="isDisabledLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
